import { useEffect, useRef } from "react";

// Polls `callback` on an interval, but pauses entirely while the browser tab
// is hidden and does one catch-up call when it becomes visible again — keeps
// idle/backgrounded tabs from hitting the server for no one to see.
export function useVisibleInterval(callback, ms) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    let id = null;
    const start = () => {
      if (!id) id = setInterval(() => cbRef.current(), ms);
    };
    const stop = () => {
      if (id) clearInterval(id);
      id = null;
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        start();
        cbRef.current();
      } else {
        stop();
      }
    };
    if (document.visibilityState === "visible") start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [ms]);
}
